import { render, staticRenderFns } from "./eventsDetail.vue?vue&type=template&id=a4492ef2&scoped=true"
import script from "./eventsDetail.vue?vue&type=script&lang=js"
export * from "./eventsDetail.vue?vue&type=script&lang=js"
import style0 from "./eventsDetail.vue?vue&type=style&index=0&id=a4492ef2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4492ef2",
  null
  
)

export default component.exports